<template>
  <div>
    <template v-if="loading_step === false">
      <div class="row">
        <ul class="col s12 collapsible matriculas">
          <template v-for="(mat, i) in rh_data">
            <li class="col s12 no-padding" v-bind:key="i" v-bind:data-id="i">
              <div class="collapsible-header">
                {{ (mat.matricula && mat.matricula.length > 0 ? mat.matricula : 'N/I') }} - {{ meta.desc_categoria_cods[mat.categoria_cod] }}
              <i v-if="validateForm[i] === true" class="material-icons">check</i>
              <i v-else class="material-icons red-text">error</i>
              </div>
              <div v-if="'extras' in mat" class="col s12 collapsible-body">
                <!-- Pensionista -->
                <template v-if="mat.categoria_cod === 3">
                  <div class="col s12 m12 docs-section">
                    <h6>Dados pessoais do instituidor</h6>
                    <div class="input-field col s12 m4">
                      <input v-model="mat.instituidor.nome" v-bind:id="`nome_${i}`" v-bind:class="{'invalid': error_fields[i][`nome_${i}`]}" type="text">
                      <label for="nome">Nome</label>
                      <span v-if="error_fields[i][`nome_${i}`]" class="helper-text" data-error="Este campo deve ser preenchido"></span>
                    </div>
                    <div class="input-field col s12 m4">
                      <input v-model="mat.instituidor.cpf" v-mask="['###.###.###-##']" v-bind:id="`cpf_${i}`" v-bind:class="{'invalid': error_fields[i][`cpf_${i}`]}" type="text">
                      <label for="cpf">CPF</label>
                      <span v-if="error_fields[i][`nome_${i}`]" class="helper-text" data-error="Este campo deve ser preenchido"></span>
                    </div>
                    <div class="input-field col s12 m3">
                      <input v-model="mat.instituidor.nascimento" v-mask="['##/##/####']" type="text" v-bind:id="`nascimento_${i}`" v-bind:class="{'invalid': error_fields[i][`nascimento_${i}`]}" />
                      <label>Data de Nascimento</label>
                      <span v-if="error_fields[i][`nome_${i}`]" class="helper-text" data-error="Este campo deve ser preenchido"></span>
                    </div>
                    <div class="input-field col s12 m3">
                      <input v-model="mat.instituidor.ppn" type="text" v-bind:id="`ppn_${i}`">
                      <label for="nit_pis_pasep">NIT/PIS/PASEP</label>
                      <span v-if="error_fields[i][`ppn_${i}`]" class="helper-text"></span>
                    </div>
                    <div class="input-field col s12 m3">
                      <input v-model="mat.instituidor.obito" v-mask="['##/##/####']" type="text" v-bind:id="`obito_${i}`" v-bind:class="{'invalid': error_fields[i][`obito_${i}`]}" />
                      <label>Data de óbito</label>
                      <span v-if="error_fields[i][`obito_${i}`]" class="helper-text" data-error="Este campo deve ser preenchido"></span>
                    </div>
                    <!-- <div class="input-field col s12 m3">
                      <input v-model="mat.lotacao.data_ingresso" v-mask="['##/##/####']" type="text" v-bind:id="`ingresso_cargo_${i}`" v-bind:class="{'invalid': error_fields[i][`ingresso_cargo_${i}`]}" />
                      <label>Início no último cargo</label>
                      <span v-if="error_fields[i][`ingresso_cargo_${i}`]" class="helper-text" data-error="Este campo deve ser preenchido"></span>
                    </div> -->
                  </div>
                </template>
                <!-- Todos as Categorias -->
                <template>
                  <div class="col s12 m12 docs-section">
                    <h6 v-if="[1, 2].includes(mat.categoria_cod) === true">Dados funcionais</h6>
                    <h6 v-else>Dados funcionais do instituidor</h6>
                    <div class="input-field col s12 m3">
                      <input v-model="mat.matricula" v-bind:id="`matricula_${i}`" type="text" v-bind:class="{'invalid': error_fields[i][`matricula_${i}`]}">
                      <label for="mat">Matrícula</label>
                      <span v-if="error_fields[i][`matricula_${i}`]" class="helper-text" data-error="Este campo deve ser preenchido"></span>
                    </div>
                    <div class="input-field col s12 m3">
                      <select v-model="mat.categoria_cod" v-bind:id="`categoria-${i}`" disabled>
                        <option v-bind:value="null" selected>Selecione</option>
                        <option v-for="(cat, i) in meta.desc_categoria_cods" v-bind:key="i" v-bind:value="i">{{ cat }}</option>
                      </select>
                      <label v-bind:for="`categoria-${i}`" class="ativar-label active">Categoria</label>
                    </div>
                    <div class="input-field col s12 m3">
                      <select v-model="mat.lotacao.lotacao_id" v-bind:id="`lotacao-${i}`" disabled>
                        <option value="null">Não disponível</option>
                        <option v-for="(lotacao, lotacao_id) in gov_data['lotacoes']" v-bind:key="lotacao_id" v-bind:value="lotacao_id">{{ lotacao['lotacao'] }}</option>
                      </select>
                      <label v-bind:for="`lotacao-${i}`" class="ativar-label active">Lotação</label>
                      <span class="helper-text disable-field-warning"><i class="material-icons">info</i><p>Neste momento não é possível alterar esta informação. Se ela estiver divergente dos documentos apresentados, a correção será realizada pela equipe de digitação.</p></span>
                    </div>
                    <div class="input-field col s12 m3">
                      <select v-model="mat.lotacao.cargo_id" v-bind:id="`cargo-${i}`" disabled>
                        <option value="null">Não disponível</option>
                        <option v-for="(cargo, cargo_id) in gov_data['cargos']" v-bind:key="cargo_id" v-bind:value="cargo_id">{{ cargo['cargo'] }}</option>
                      </select>
                      <label v-bind:for="`cargo-${i}`">Cargo</label>
                      <span class="helper-text disable-field-warning"><i class="material-icons">info</i><p>Neste momento não é possível alterar esta informação. Se ela estiver divergente dos documentos apresentados, a correção será realizada pela equipe de digitação.</p></span>
                    </div>
                    <div class="input-field col s12 m3">
                      <input v-model="mat.data_movimento" v-mask="['##/##/####']" type="text" v-bind:id="`data_movimento_${i}`" v-bind:class="{'invalid': error_fields[i][`data_movimento_${i}`]}" />
                      <label for="data_ingresso">Data de ingresso</label>
                      <span v-if="error_fields[i][`data_movimento_${i}`]" class="helper-text" data-error="Este campo deve ser preenchido"></span>
                    </div>
                    <!-- <template v-if="mat.categoria_cod === 1">
                      <div class="input-field col s12 m3">
                        <input v-model="mat.extras.data_abono_permanencia" v-mask="['##/##/####']" type="text" />
                        <label>Data de Abono permanência</label>
                      </div>
                    </template> -->
                  </div>
                </template>
                <!-- Penistas e Aposentados -->
                <template v-if="[2, 3].includes(mat.categoria_cod) === true">
                  <div class="col s12 m12 docs-section">
                    <h6>Dados do benefício</h6>
                    <div class="input-field col s12 m4">
                      <select v-model="mat.beneficio.tipo" v-bind:id="`beneficio_tipo-${i}`" disabled>
                        <option v-bind:value="null" selected>Selecione</option>
                        <option v-for="(categoria, categoria_id) in tipos_elegiveis(mat.categoria_cod)" v-bind:key="categoria_id" v-bind:value="categoria_id">{{ categoria }}</option>
                      </select>
                      <label v-bind:for="'beneficio_tipo-${i}'">Categoria do benefício</label>
                      <span class="helper-text disable-field-warning"><i class="material-icons">info</i><p>Neste momento não é possível alterar esta informação. Se ela estiver divergente dos documentos apresentados, a correção será realizada pela equipe de digitação.</p></span>
                    </div>
                    <div class="input-field col s12 m4">
                      <select v-model="mat.beneficio.regra" v-bind:class="{'invalid': error_fields[i][`regra_${i}`]}" v-bind:id="`regra_${i}`">
                        <option v-bind:value="null" selected>Selecione</option>
                        <option v-for="(tipo, tipo_id) in beneficios_elegiveis(mat.categoria_cod)" v-bind:key="tipo_id" v-bind:value="tipo_id">{{ tipo }}</option>
                      </select>
                      <label for="regra">Tipo do benefício</label>
                      <span v-if="error_fields[i][`regra_${i}`]" class="helper-text" data-error="Este campo deve ser preenchido"></span>
                    </div>
                    <template v-if="mat.categoria_cod === 2">
                      <div class="input-field col s12 m4">
                        <input v-model="mat.beneficio.data_concessao" v-mask="['##/##/####']" type="text" v-bind:class="{'invalid': error_fields[i][`data_concessao_${i}`]}" v-bind:id="`data_concessao_${i}`" />
                        <label>Data de concessão</label>
                        <span v-if="error_fields[i][`data_concessao_${i}`]" class="helper-text" data-error="Este campo deve ser preenchido"></span>
                      </div>
                    </template>
                    <template v-else>
                      <div class="input-field col s12 m4">
                        <input v-model="mat.pensionistas_obj[pf_id].data_concessao" v-mask="['##/##/####']" type="text" v-bind:class="{'invalid': error_fields[i][`data_concessao_${i}`]}" v-bind:id="`data_concessao_${i}`" />
                        <label>Data de concessão</label>
                        <span v-if="error_fields[i][`data_concessao_${i}`]" class="helper-text" data-error="Este campo deve ser preenchido"></span>
                      </div>
                    </template>
                  </div>
                </template>
                <div class="col s12 m12">
                  <button @click="prepareSubmitMatricula(mat)" v-bind:disabled="validateForm[i] === false" class="btn primary right" type="button">Salvar</button>
                </div>
              </div>
            </li>
          </template>
        </ul>
      </div>
      <div class="step-actions">
        <button class="waves-effect waves-dark btn-flat previous-step">Anterior</button>
        <button v-bind:disabled="step_completed === false" type="button" @click="submitStep" class="waves-effect waves-dark btn">Próximo</button>
      </div>
    </template>
    <template v-else>
      <loading />
    </template>
  </div>
</template>
<script>
import {formataData, converteData, verificaData, validaCPF} from '@/assets/js/form-utils.js'
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import { CONFIG } from '@/config/config.js'
import SocialService from '@/services/social-service.js'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)
let uuid_service = require("uuid")

export default {
  name: 'Servidor',
  components: {
    loading: Loading
  },
  props: {
    stepper: Object,
    active_step: Number,
    rh_dados: Object,
    social_data_inst: Object,
    gov_data: Object,
  },
  data (){
    return {
      meta: this.$store.state.meta.data,
      pf_id: this.$store.state.user.pfId,
      loading_step: false,
      changed: false,
      step_completed: false,
      collapsible: null,
      categorias_beneficio: {
        'aposentadoria': "Aposentadoria",
        'pensao': "Pensão",
        'auxilio': "Auxílios previdenciários"
      },
      tipos_beneficio: {
        'aposentadoria': {
          'compulsoria': "Aposentadoria compulsória",
          'invalidez': "Aposentadoria por Invalidez",
          'idade': "Aposentadoria por Idade",
          'idade_tempo': "Aposentadoria por Idade e Tempo de Contribuição",
          'art2': "Aposentadoria pelo Art. 2 EC 41/2003",
          'art3': "Aposentadoria pelo Art. 3 EC 47/2005",
          'art6': "Aposentadoria pelo Art. 6 EC 41/2003",
        },
        'pensao': {
          'pensao': "Pensão por Morte"
        },
        'auxilio': {
          'auxilio_maternidade': "Auxílio Materninade",
          'auxilio_doença': "Auxílio Doença",
          'auxilio_reclusao': "Auxílio Reclusão"
        }
      },
      rh_data: this.rh_dados,
      error_fields: {},
      error: null
    }
  },
  computed: {
    validateForm: function () {
      let mats = {}
      for(let s_id in this.rh_data){
        try {
          this.$set(this.error_fields, s_id, {})
          let mat = this.rh_data[s_id]
          let status = false

          //Matrícula do Servidor Titular
          if((mat.matricula === null || mat.matricula.length < 1)){
            this.$set(this.error_fields[s_id], `matricula_${s_id}`, true) //ERROR
          } else {
            this.$set(this.error_fields[s_id], `matricula_${s_id}`, false)
          }

          //Data de ingresso
          if((verificaData(mat.data_movimento) === false)){
            this.$set(this.error_fields[s_id], `data_movimento_${s_id}`, true) //ERROR
          } else {
            this.$set(this.error_fields[s_id], `data_movimento_${s_id}`, false)
          }

          //APENAS APOSENTADOS E PENSIONISTAS
          if([2, 3].includes(mat.categoria_cod)){
            //Regra de aposentadoria/pensão
            let el = document.getElementById(`regra_${s_id}`)
            if(mat.beneficio.regra === null){
              this.$set(this.error_fields[s_id], `regra_${s_id}`, true) //ERROR
              if(el){
                M.FormSelect.getInstance(el).wrapper.classList.add('invalid')
              }
            } else {
              this.$set(this.error_fields[s_id], `regra_${s_id}`, false)
              if(el){
                M.FormSelect.getInstance(el).wrapper.classList.remove('invalid')
              }
            }
            
            //Data de concessão da aposentadoria/pensão
            let data_concessao = (mat.categoria_cod === 2 ? mat.beneficio.data_concessao : mat.pensionistas_obj[this.pf_id].data_concessao)
            if((verificaData(data_concessao) === false)){
              this.$set(this.error_fields[s_id], `data_concessao_${s_id}`, true) //ERROR
            } else {
              this.$set(this.error_fields[s_id], `data_concessao_${s_id}`, false)
            }
          }

          //APENAS PENSIONISTAS
          if(mat.categoria_cod === 3 && mat.instituidor !== undefined){
            //Nome do Insituidor
            if((!mat.instituidor.nome || mat.instituidor.nome === null || mat.instituidor.nome.length < 3)){
              this.$set(this.error_fields[s_id], `nome_${s_id}`, true) //ERROR
            } else {
              this.$set(this.error_fields[s_id], `nome_${s_id}`, false)
            }

            //CPF do Insituidor
            if((!mat.instituidor.cpf || mat.instituidor.cpf === null || validaCPF(mat.instituidor.cpf) === false)){
              this.$set(this.error_fields[s_id], `cpf_${s_id}`, true) //ERROR
            } else {
              this.$set(this.error_fields[s_id], `cpf_${s_id}`, false)
            }

            //Data de Nascimento do Insituidor
            if((mat.instituidor.nascimento === null || verificaData(mat.instituidor.nascimento) === false)){
              this.$set(this.error_fields[s_id], `nascimento_${s_id}`, true) //ERROR
            } else {
              this.$set(this.error_fields[s_id], `nascimento_${s_id}`, false)
            }

            //Data de Óbito do Insituidor
            if((mat.instituidor.obito === null || verificaData(mat.instituidor.obito) === false)){
              this.$set(this.error_fields[s_id], `obito_${s_id}`, true) //ERROR
            } else {
              this.$set(this.error_fields[s_id], `obito_${s_id}`, false)
            }

            //É Professor?
            let el = document.getElementById(`efetivo_magesterio_${s_id}`)
            if(mat.extras.efetivo_magesterio === null){
              this.$set(this.error_fields[s_id], `efetivo_magesterio_${s_id}`, true) //ERROR
              if(el){
                M.FormSelect.getInstance(el).wrapper.classList.add('invalid')
              }
            } else {
              this.$set(this.error_fields[s_id], `efetivo_magesterio_${s_id}`, false)
              if(el){
                M.FormSelect.getInstance(el).wrapper.classList.remove('invalid')
              }
            }

            //É Professor Universitário?
            el = document.getElementById(`efetivo_magesterio_superior_${s_id}`)
            if(mat.extras.efetivo_magesterio_superior === null){
              this.$set(this.error_fields[s_id], `efetivo_magesterio_superior_${s_id}`, true) //ERROR
              if(el){
                M.FormSelect.getInstance(el).wrapper.classList.add('invalid')
              }
            } else {
              this.$set(this.error_fields[s_id], `efetivo_magesterio_superior_${s_id}`, false)
              if(el){
                M.FormSelect.getInstance(el).wrapper.classList.remove('invalid')
              }
            }
          }

          mats[s_id] = Object.keys(this.error_fields[s_id]).map(k => k).filter(k => this.error_fields[s_id][k] === true).length === 0
          //this.step_completed = mats[s_id]
        } catch(e) {
          console.log(e)
        }
      }
      return mats
    }
  },
  methods: {
    submitServidor(mat){
      let pensionistas = []
      //Organiza o array de pensionistas, quando for o caso
      if(mat.categoria_cod === 3){
        mat.pensionistas.forEach(p => {
          pensionistas.push({
            'pf_id': p['pf_id'],
            'data_concessao': formataData(p['data_concessao'])
          })
        })
      }

      return axios.put(`${CONFIG.URL_RH_API_V2}/v1/servidor/${mat.servidor_id}/universal/`, {
        "matricula": mat.matricula,
        "categoria_cod": parseInt(mat.categoria_cod),
        "data_movimento": formataData(mat.data_movimento),
        "pensionistas": pensionistas
      })
    },
    submitLotacaoInstituidor(mat){
      axios.put(`${CONFIG.URL_RH_API_V2}/v1/servidor/${mat.servidor_id}/lotacao/`, {
        "lotacao_id": mat.lotacao.lotacao_id,
        "cargo_id": mat.lotacao.cargo_id,
        "data_ingresso": formataData(mat.lotacao.data_ingresso),
      })
      .then((response) => {
      })
      .catch((error) => {})
    },
    async submitPerfilInstituidor(mat){
      let payload_perfil = {
        "cpf":  (mat.instituidor.pf_cpf_valid === false && mat.instituidor.cpf.replace(/[^0-9]/g, '') != mat.instituidor.cpf_loaded && validaCPF(mat.instituidor.cpf) ? mat.instituidor.cpf : null),
        "nome":  (mat.instituidor.pf_cpf_valid === false ? mat.instituidor.nome : null),
        "nascimento": (mat.instituidor.pf_cpf_valid === false && verificaData(mat.instituidor.nascimento) === true ? formataData(mat.instituidor.nascimento) : null),
        "obito": (verificaData(mat.instituidor.obito) === true ? formataData(mat.instituidor.obito) : null),
        "device": await socialService.getDeviceInfo()
      }

      //Remove o CPF quando ele não foi alterado
      if(payload_perfil['cpf'] === null){
        delete payload_perfil['cpf']
      }

      axios.patch(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/perfil/${mat.pf_id}/`, payload_perfil)
      .then((response) => {

      })
      .catch((error) => {
        if(error.response.status === 400){
            //Usuário tentou cadastrar CPF já existente
            M.toast({html: 'O CPF informado já se encontrado cadastrado e vinculado a outra pessoa!'})
            mat.instituidor.cpf = ''
        } else {
          this.loading_dep = false
          this.$root.$emit('stopLoadingHeader')
          this.initFields()
          M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        }
      })
    },
    async submitPpnInstituidor(ppn, pf_instituidor){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/ppn/`, {
        'pf_ppn': ppn,
        'pf_ppn_emissao': null,
        'pf_id': pf_instituidor,
        'device': await socialService.getDeviceInfo()
      })
      .then((response) => {
      })
      .catch((error) => {
      })
      .finally(() => {
        this.loading_step = false
        this.initStep()
      })
    },
    submitServidorExtras(mat){
      axios.put(`${CONFIG.URL_RH_API_V2}/v2/servidor/extras/${mat.servidor_id}/`, {
        "servidor_id": mat.servidor_id,
        "pf_id": mat.pf_id,
        "pf_id_pensionista": null, //Quem acessa esta APP é o pensionista, já que o instituidor não pode mais fazê-lo.
        "exposto_agentes_nocivos": (mat.extras.exposto_agentes_nocivos ? mat.extras.exposto_agentes_nocivos : false),
        "data_exposto_agentes_nocivos": (mat.extras.data_exposto_agentes_nocivos ? formataData(mat.extras.data_exposto_agentes_nocivos) : null),
        "efetivo_magesterio": (mat.extras.efetivo_magesterio ? mat.extras.efetivo_magesterio : false),
        "efetivo_magesterio_superior": (mat.extras.efetivo_magesterio_superior ? mat.extras.efetivo_magesterio_superior : false),
        "data_abono_permanencia": (mat.categoria_cod === 1 && verificaData(mat.extras.data_abono_permanencia) === true ? formataData(mat.extras.data_abono_permanencia) : null)
      })
      .then((response) => {})
      .catch((error) => {})
      .finally(() => {
        this.loading_step = false
        this.initStep()
      })
    },
    submitServidorBeneficio(mat){
      axios.put(`${CONFIG.URL_RH_API_V2}/v1/servidor/${mat.servidor_id}/beneficio/universal/`, {
        'tipo': mat.beneficio.tipo,
        'regra': mat.beneficio.regra,
        'data_concessao': formataData(mat.beneficio.data_concessao),
        'paridade_ativos': mat.beneficio.paridade_ativos,
        'extincao': mat.beneficio.extincao,
        'observacao': '(empty)'
      })
      .then((response) => {})
      .catch((error) => {})
      .finally(() => {
        this.loading_step = false
        this.initStep()
      })
    },
    async prepareSubmitMatricula(mat){
      this.loading_step = true
      await this.submitServidor(mat)
      this.loading_step = false
      this.initStep()
      // this.submitServidorExtras(mat)

      if(mat.categoria_cod === 3){
        this.submitPerfilInstituidor(mat)
        // this.submitLotacaoInstituidor(mat)

        if (mat.instituidor.ppn){
          this.submitPpnInstituidor(mat.instituidor.ppn, mat.pf_id)
        }

        this.loading_step = false
        this.initStep() 
      }

      //Pensionistas
      if(mat.categoria_cod === 2){
        this.submitServidorBeneficio(mat)
      }
    },
    async submitPerfil(){
      this.$root.$emit('loadingHeader')
      this.loading_step = true
      localStorage[`mat_${this.pf_id}`] = JSON.stringify(this.matricula)

      setTimeout(() => {
        this.$root.$emit('stopLoadingHeader')
        this.loading_step = false
        this.$emit('moveNextStep', {step: 4, completed: this.step_completed})
      }, 1000)
    },
    tipos_elegiveis(categoria_cod) {
      let benefs_categorias = {2: 'aposentadoria', 3: 'pensao', 8: 'auxilio', 9: 'auxilio', 10: 'auxilio'}
      let disponiveis = {}
      disponiveis[benefs_categorias[categoria_cod]] = this.categorias_beneficio[benefs_categorias[categoria_cod]]
      return disponiveis
    },
    beneficios_elegiveis (categoria_cod) {
      let categorias = {}
      let benefs_categorias = {2: 'aposentadoria', 3: 'pensao', 8: 'auxilio', 9: 'auxilio', 10: 'auxilio'}
      return this.tipos_beneficio[benefs_categorias[categoria_cod]]
    },
    submitStep() {
      if(this.changed === true){
        this.submitPerfil()
      } else {
        this.$emit('moveNextStep', {step: 4, completed: this.step_completed})
      }
    },
    verificaStatusPasso(){
      let status = true
      for(let s_id in this.error_fields){
        if(Object.keys(this.error_fields[s_id]).map(k => k).filter(k => this.error_fields[s_id][k] === true).length > 0){
          return false
        }
      }
      return status
    },
    initStep(){
      setTimeout(() => {
        M.updateTextFields()
        M.FormSelect.init(document.querySelectorAll('select'))
        M.Tooltip.init(document.querySelectorAll('.tooltipped'))
        M.Collapsible.init(document.querySelectorAll('.collapsible.matriculas'))
        this.collapsible = M.Collapsible.getInstance(document.querySelectorAll('.collapsible.matriculas')[0])
        this.changed = false
      }, 200)
    }
  },
  watch: {
    rh_data: {
      handler: function(updated_perfil, old_perfil){
        setTimeout(() => {
          this.step_completed = this.verificaStatusPasso()
        }, 300)
      },
      deep: true
    },
    rh_dados: function(updated_rh_dados, old_rh_dados) {
      this.rh_data = updated_rh_dados
    }
  },
  mounted(){
    this.initStep()
    setTimeout(() => {
      this.step_completed = this.verificaStatusPasso()
    }, 300)
  }
}
</script>


// WEBPACK FOOTER //
// src/components/steps/Servidor.vue